import { Component, HostBinding, HostListener, Input, OnInit, ViewEncapsulation } from '@angular/core';

export interface ModalAction {
  action: () => void;
  label: string;
  svg?: string;
  type: ModalActionType;
}

export interface CloseAction extends ModalAction {
  type: ModalActionType.Close;
}

export type ModalActions = [CloseAction, ...ModalAction[]];

export enum ModalActionType {
  Destructive = 'destructive',
  Positive = 'positive',
  Close = 'close'
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-modal',
  styleUrls: ['./modal.component.scss'],
  templateUrl: './modal.component.html'
})
export class ModalComponent implements OnInit {
  @Input() actionDisabled: boolean;
  @Input() actions: ModalActions;
  @Input() isForm: boolean;
  @Input() enableFooter = true;
  // title is a html attribute that will render a tooltip - even when not needed
  @Input() modalTitle: string;
  @Input() largeModal: boolean;

  type = ModalActionType;

  @HostBinding('class.larger')
  @HostListener('window:keyup.esc')
  modalClose(): void {
    let { Close } = this.type;
    let modalClose = this.actions.find((action) => action.type === Close);
    modalClose.action();
  }

  constructor() {}

  ngOnInit(): void {}

  buttonTestId(buttonLabel: string): string {
    return `modal-${buttonLabel?.toLowerCase().replace(/ /g, '-')}-btn`;
  }
}
